import React from "react";
import { Scale, Building2, ShieldCheck, Gem, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1709734110054-3b0db38c959c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxmb3VudGFpbiUyMHBlbiUyMGZpbmFuY2lhbCUyMGRvY3VtZW50fGVufDB8fHx8MTc4MzMzMjk1MXww&ixlib=rb-4.1.0&q=85";

const icons = [Scale, Building2, ShieldCheck, Gem];

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-24 md:py-32 bg-[#0A0A0B]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="mb-16 md:mb-20 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span className="flo-label">{t.services.label}</span>
          </div>
          <h2 className="font-serif-display text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.98]">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-5 relative overflow-hidden rounded-lg border border-white/10 min-h-[320px]">
            <Reveal className="h-full">
              <img src={IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60 hover:scale-105 transition-transform duration-[1.5s] ease-out" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/40 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <p className="font-serif-display text-2xl md:text-3xl text-white leading-tight italic">
                  {t.services.items[0].t}
                </p>
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {t.services.items.map((s, i) => {
              const Icon = icons[i];
              return (
                <Reveal
                  key={s.t}
                  delay={i * 0.06}
                  className="group relative p-8 bg-[#18181B] border border-white/10 rounded-lg hover:border-gold/40 transition-colors duration-500"
                  data-testid={`service-card-${i}`}
                >
                  <div className="flex items-start justify-between mb-6">
                    <Icon size={26} className="text-gold" strokeWidth={1.3} />
                    <ArrowUpRight size={18} className="text-zinc-600 group-hover:text-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300" />
                  </div>
                  <h3 className="font-serif-display text-white text-xl md:text-2xl tracking-tight mb-3">{s.t}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">{s.d}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
